//export const phoneRegex =
//  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;
export const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
export const SSNRegex = /^\d{3}\-?\d{2}\-?\d{4}$/;
export const taxIdRegex = /^\d{2}\-?\d{7}$/;
